<script>
    // import {flow_info, flow_stack} from './stores.js';
    import{user_data} from './stores.js';
    import { onMount } from "svelte";
    import Dtemplate from "./components/detailedtemplate.svelte";
    import Progresscomponent from "./components/progresscomponent.svelte";
    // import Listcomponent from './components/listcomponent.svelte';
    import Listcomponent from './components/listcomponent.svelte';
    export let listdata = [
        {s: true, t: "Get pre-approved", cbf:()=>{$user_data.howcanwehelp = "Get pre-approved";}},
        {s: false, t: "How much can I afford?", cbf:()=>{$user_data.howcanwehelp = "How much can I afford?";}},
        {s: false, t: "How much will a home cost?", cbf:()=>{$user_data.howcanwehelp = "How much will a home cost?";}},
    ];

    onMount(async() => {

    });

</script>

<Dtemplate
progress_mobile_version={true}
show_icon_card={true}
>
    <Progresscomponent 
    title="How can we help you?"
    show_next_button={false}
    >
    <Listcomponent
        bind:listdata={listdata}
    />
    </Progresscomponent>
</Dtemplate>

<style>

</style>